var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { Routes } from "../Shared/components/Navigation/navigationUtils";
/**
 * Single use axios instance
 */
export default axios.create();
/**
 * Instance of axios to be used for all requests. Has response interceptors attached to handle Refresh token.
 */
export const axiosPrivate = axios.create();
const existingCustomer = localStorage.getItem("mt-customer") === "true";
const nextRoute = existingCustomer ? Routes.LOGIN : Routes.REGISTER;
/**
 * This interceptor is used before setupInterceptors is called.
 * This will not be called with RequireAuth implemented but we leave it here for safety.
 */
const initialInterceptor = axiosPrivate.interceptors.response.use((response) => response, (error) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        try {
            const response = yield axios.post("/Refresh");
            if (response.status === 200) {
                return axiosPrivate(error.config).then((res) => {
                    return res;
                });
            }
        }
        catch (error) {
            window.location.href = Routes.LOGIN;
            return Promise.reject(error);
        }
    }
    return Promise.reject(Object.assign({}, error));
}));
/**
 * Try to fetch another Refresh token. If that fails redirect to Login
 *
 * @param error
 * @param navigate NavigateFunction
 * @param location Location
 * @returns
 */
const onRejected = (error, navigate, location, authContext) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    if (((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
        try {
            const response = yield axios.post("/Refresh");
            if (response.status === 200) {
                return axiosPrivate(error.config).then((res) => {
                    authContext.setIsAuthenticated(true);
                    authContext.setRetry(false);
                    return res;
                });
            }
        }
        catch (error) {
            authContext.setIsAuthenticated(false);
            authContext.setRetry(false);
            navigate(nextRoute, {
                replace: true,
                state: { prevRoute: location.pathname },
            });
        }
    }
    return Promise.reject(Object.assign({}, error));
});
/**
 * Applies an interceptor to the axiosPrivate instance to handle Refresh tokens
 *
 *
 * @param navigate NavigateFunction
 * @param location Location
 */
export const setupInterceptors = (navigate, location, authContext) => {
    // Eject default interceptor
    axiosPrivate.interceptors.response.eject(initialInterceptor);
    // Apply interceptor to handle refresh token and navigate on failure
    axiosPrivate.interceptors.response.use((response) => response, (error) => onRejected(error, navigate, location, authContext));
};
/**
 * Check authentication state and refreshes if needed
 *
 * @param navigate
 * @param location
 * @param authContext
 */
export const checkAuthentication = (authContext) => __awaiter(void 0, void 0, void 0, function* () {
    // This function runs every time RequireAuth or LoginRegisterShell render which most likely happens after onRejected. 
    // If retry is false, onRejected just ran so don't run this again 
    if (!authContext.retry)
        return;
    authContext.setLoading(true);
    try {
        const response = yield axios.post("/Refresh?check=true");
        if (response.status === 200) {
            authContext.setIsAuthenticated(true);
        }
    }
    catch (error) {
        authContext.setIsAuthenticated(false);
    }
    finally {
        authContext.setLoading(false);
    }
});
